import { WindowLocation } from '@gatsbyjs/reach-router'
import React, { FC, useContext, useEffect, useState } from 'react'

import { setSessionStorageState } from '../hooks/useStorage'
import { LocationContext } from '../lib/pages/context'
import { sessionOrFallbackStorage } from '../utils/storage'

export const LocationContextProvider: FC = ({ children }) => {
  const [location, setLocation] = useState<WindowLocation | null>(null)
  return (
    <LocationContext.Provider value={{ location, setLocation }}>
      {children}
    </LocationContext.Provider>
  )
}

export const LocationContextUpdate: FC<{ location: WindowLocation }> = ({ children, location }) => {
  const { setLocation } = useContext(LocationContext)

  useEffect(() => {
    setLocation(location)

    return () => {
      // set storage and signal directly to avoid unnecessary render when previousHref changes
      sessionOrFallbackStorage.setItem('previousHref', location.href)
      setSessionStorageState('previousHref', location.href)
    }
  }, [location, location.href, setLocation])

  return <>{children}</>
}
